import { Locales } from "@/enums/enums";
import { i18n } from "@/i18n";
import { PositionDetailModel } from "@/model/position/positionDetailModel";
import { PositionModel } from "@/model/position/positionModel";
import { PositionTableModel } from "@/model/position/positionTableModel";
/* eslint-disable @typescript-eslint/camelcase */
export function ConvertToPositionDetail(positionDetail: any): PositionDetailModel {
  const positionDetailModal: PositionDetailModel = {
    id: positionDetail.id,
    merchantId: positionDetail.merchantId,
    departmentId: positionDetail.departmentId,
    code: positionDetail.code,
    nameTh: positionDetail.nameTh,
    nameEn: positionDetail.nameEn,
    nameLocale: i18n.locale === Locales.TH ? positionDetail.nameTh : positionDetail.nameEn,
    isMain: positionDetail.isMain,
    accountId: positionDetail.accountId,
    type: positionDetail.type,
    isArchived: positionDetail.isArchived,
    isDeleted: positionDetail.isDeleted,
  };
  return positionDetailModal;
}

export function ConvertToPositionTable(table: any) {
  const positionTable: any = {
    count: table.count,
    tableList: [],
  };

  if (table.tableList.length > 0) {
    table.tableList.forEach((tableItem: any) => {
      const positionTableModel: PositionTableModel = {
        id: tableItem.id,
        code: tableItem.code,
        nameEn: tableItem.nameEn,
        nameTh: tableItem.nameTh,
        nameLocale: i18n.locale === Locales.TH ? tableItem.nameTh : tableItem.nameEn,
        isArchived: tableItem.isArchived,
        accountId: tableItem.accountId,
        employeeCount: tableItem.employeeCount,
      };

      positionTable.tableList.push(positionTableModel);
    });
  }

  return positionTable;
}

export function ConvertToPositionList(positionList: any) {
  const positionListModel: Array<PositionModel> = [];

  if (positionList.length > 0) {
    positionList.forEach((positionItem: any) => {
      const positionModel: PositionModel = {
        id: positionItem.id,
        code: positionItem.code,
        departmentId: positionItem.departmentId,
        nameTh: positionItem.nameTh,
        nameEn: positionItem.nameEn,
        nameLocale: i18n.locale === Locales.TH ? positionItem.nameTh : positionItem.nameEn,
        type: positionItem.type,
        accountId: positionItem.accountId,
        isArchived: positionItem.isArchived,
      };
      positionListModel.push(positionModel);
    });
  }

  return positionListModel;
}
